import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';

const PrintTemplate = ({ open, onClose, title, children }) => {

    useEffect(() => {
        import('./print.css').then(() => {});
    }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: { 
          minHeight: '80vh',
          maxHeight: '90vh',
          margin: '16px',
          overflowY: 'auto'
        }
      }}
    >
      <DialogContent>
        <div className="print-preview">
          <div className="print-content">
            <h1>{title}</h1>
            {children}
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
        <Button onClick={handlePrint} variant="contained" color="primary">
          Imprimir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintTemplate;